import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ZoomIn, X, ChevronLeft, ChevronRight } from 'lucide-react';

const images = [
  {
    src: '/static/media/gallery-certificate.d357f735032f6f7ec8ae.jpeg',
    title: 'Certification',
    caption:
      'Certified Career Analyst credential — Government of India recognised qualification held by CCA Arendra Nath Sharma.',
  },
  {
    src: '/static/media/gallery-display.54591516703df66bcf5b.jpeg',
    title: 'Career Counselling Session',
    caption:
      'A live career counselling and psychometric assessment session conducted by Vitae Career Enterprises.',
  },
  {
    src: '/static/media/gallery-teach.bb05c2eb5ed241fff4b2.jpeg',
    title: 'Outreach & Guidance',
    caption:
      'Reaching students across Lucknow and Balrampur with expert career guidance workshops.',
  },
  {
    src: '/static/media/About.95ed9b052facbd10084c.jpeg',
    title: 'CCA Arendra Nath Sharma',
    caption:
      'Founder & Director — Former DDG (Engineering), Ministry of Information & Broadcasting, Government of India.',
  },
];

const Gallery = () => {
  const [active, setActive] = useState(null);
  const close = () => setActive(null);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <section className="Gallery_hero__eyzBY">
        <div className="container Gallery_heroContainer__cZhlZ">
          <motion.span
            className="section-label"
            style={{ color: 'var(--c-gold)' }}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            MOMENTS &amp; MILESTONES
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            Gallery
          </motion.h1>
          <motion.p
            className="Gallery_heroSubtext__PLJet"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            A glimpse into the work, sessions, and credentials of Vitae Career
            Enterprises.
          </motion.p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="Gallery_grid__Hbfpj">
            {images.map((e, t) => (
              <motion.div
                key={t}
                className="Gallery_card__y2Kyj"
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 * t, duration: 0.4 }}
                onClick={() => setActive(t)}
              >
                <div className="Gallery_imgWrap__fKs8m">
                  <img src={e.src} alt={e.title} className="Gallery_img__4xoCR" />
                  <div className="Gallery_overlay__fTj8R">
                    <ZoomIn size={28} className="Gallery_zoomIcon__x66bL" />
                    <span className="Gallery_overlayLabel__H2COA">
                      View Full Image
                    </span>
                  </div>
                </div>
                <div className="Gallery_cardBody__LABgC">
                  <h3 className="Gallery_cardTitle__CLKb-">{e.title}</h3>
                  <p className="Gallery_cardCaption__AVeSh">{e.caption}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container Gallery_cta__+fUKy">
          <h2>Ready to Start Your Career Journey?</h2>
          <p>
            Join the students and professionals who have already found clarity
            through Vitae Career Enterprises.
          </p>
          <div className="Gallery_ctaButtons__oaNmT">
            <a
              href="https://vitaecareer.edumilestones.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Explore Your True Potential &#8594;
            </a>
          </div>
        </div>
      </section>

      <AnimatePresence>
        {active !== null && (
          <motion.div
            className="Gallery_lightboxBackdrop__mI0uo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={close}
          >
            <motion.div
              className="Gallery_lightboxContent__+szUJ"
              initial={{ scale: 0.88, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.88, opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={(ev) => ev.stopPropagation()}
            >
              <button
                className="Gallery_closeBtn__aMdwC"
                onClick={close}
                aria-label="Close"
              >
                <X size={24} />
              </button>
              <button
                className="Gallery_navBtn__BroiY Gallery_navPrev__Lz+PQ"
                onClick={(ev) => {
                  ev.stopPropagation();
                  setActive((active - 1 + images.length) % images.length);
                }}
                aria-label="Previous"
              >
                <ChevronLeft size={28} />
              </button>
              <img
                src={images[active].src}
                alt={images[active].title}
                className="Gallery_lightboxImg__AnIZi"
              />
              <button
                className="Gallery_navBtn__BroiY Gallery_navNext__cVMKf"
                onClick={(ev) => {
                  ev.stopPropagation();
                  setActive((active + 1) % images.length);
                }}
                aria-label="Next"
              >
                <ChevronRight size={28} />
              </button>
              <div className="Gallery_lightboxMeta__sl2Dc">
                <strong>{images[active].title}</strong>
                <span>{images[active].caption}</span>
              </div>
            </motion.div>
            <div className="Gallery_dots__xO15Z">
              {images.map((e, r) => (
                <button
                  key={r}
                  className={`Gallery_dot__8Jfz+ ${
                    r === active ? 'Gallery_dotActive__CQm2F' : ''
                  }`}
                  onClick={(ev) => {
                    ev.stopPropagation();
                    setActive(r);
                  }}
                  aria-label={`Image ${r + 1}`}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Gallery;
